import * as Sentry from '@sentry/react';

export function initSentry() {
  // Only initialize Sentry in production
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,

      // Performance Monitoring
      tracesSampleRate: 0.1, // 10% of transactions for performance monitoring

      // Filter out expected errors
      beforeSend(event, hint) {
        // Don't send auth check failures (expected for logged out users)
        if (event.message?.includes('Auth check failed')) {
          return null;
        }

        // Don't send network errors from rate limiting (expected)
        if (event.message?.includes('429')) {
          return null;
        }

        return event;
      },

      // Add user context
      beforeBreadcrumb(breadcrumb) {
        // Filter out sensitive data from breadcrumbs
        if (breadcrumb.category === 'console' && breadcrumb.message?.includes('password')) {
          return null;
        }
        return breadcrumb;
      },
    });
  }
}

// Helper to manually capture events
export function captureError(error: Error, context?: Record<string, any>) {
  Sentry.captureException(error, {
    extra: context,
  });
}

// Helper to add user context
export function setUserContext(user: { id: string; email: string; role: string }) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    role: user.role,
  });
}

// Helper to clear user context on logout
export function clearUserContext() {
  Sentry.setUser(null);
}

// Helper to track performance
export function trackPerformance(name: string, operation: () => void | Promise<void>) {
  const span = Sentry.startSpan({ name }, () => {
    return operation();
  });

  return span;
}
